import React, {Component} from 'react';

import Profile from './Profile.connect';
import Logo from '../Logo';
import Icon from './SidebarIcon';

import {SidebarBlock} from '../MainBlocks';
import {LogoWrapper, LinkContainer, Link, SectionGroup, SectionDivider} from './Sidebar.styled';
import {
  DashboardMenuItem,
  RentalDashboardMenuItem,
  RentalMapMenuItem,
  StatisticsByDayMenuItem,
  StatisticsReportsMenuItem,
  ChargePointsMenuItem,
  LocationsMenuItem,
  MapMenuItem,
  AspMenuItem,
  ProfileMenuItem,
  RentalLocationsMenuItem,
  RentalDocumentsMenuItem,
  RentalVehiclesMenuItem,
  RentalRentalsMenuItem,
  RentalCalendarMenuItem,
  RentalClientsMenuItem,
  RentalPaymentOperationsMenuItem,
  RentalSettingsMenuItem,
} from '../SidebarMenuItems';
import MenuItem from '../MenuItem';
import {RENTAL, sectionByPath, canUseRental, canUseCharging} from '../SidebarSections';

class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  handleToggle = () => {
    this.setState({ visible: !this.state.visible });
  };

  render() {
    const {loggedIn, t} = this.props;
    const {visible} = this.state;
    const pathName = window.location.pathname.split('/')[1];
    const section = sectionByPath(pathName);

    const role = this.props.role;
    const isAdministrator = role === 'administrator';
    const isAppDeveloper = role === 'app-developer';
    const isAccounter = role === 'accounter';
    const isManager = role === 'manager';
    const isOperator = role === 'operator';
    const isRentalManager = role === 'rental-manager';

    const showRental = canUseRental(role);
    const showCharging = canUseCharging(role);
    const showSwitcher = showRental && showCharging;

    return (
      <SidebarBlock visible={visible}>

        <LogoWrapper>
          <Logo width="132" height="46" fillColor="blue" />
        </LogoWrapper>

        <Profile />

        <LinkContainer>
          {showSwitcher && (
            <SectionGroup>
              <MenuItem
                to="/rental/dashboard"
                active={section === RENTAL}
                startIcon={<Icon type={section === RENTAL ? 'stationsActive' : 'stations'} />}
              >
                Прокат
              </MenuItem>
              <MenuItem
                to="/charge-points"
                active={section !== RENTAL}
                startIcon={<Icon type={section !== RENTAL ? 'stationsActive' : 'stations'} />}
              >
                Зарядные станции
              </MenuItem>
              <SectionDivider />
            </SectionGroup>
          )}

          {section === RENTAL && showRental && (
            <>
              <RentalDashboardMenuItem pathName={pathName} />
              <RentalCalendarMenuItem pathName={pathName} />
              <RentalDocumentsMenuItem pathName={pathName} />
              <RentalVehiclesMenuItem pathName={pathName} />
              <RentalRentalsMenuItem pathName={pathName} />
              <RentalClientsMenuItem pathName={pathName} />
              <RentalPaymentOperationsMenuItem pathName={pathName} />
              <RentalMapMenuItem pathName={pathName} />
              <RentalLocationsMenuItem pathName={pathName} />
              {isAdministrator && <RentalSettingsMenuItem pathName={pathName} />}
            </>
          )}

          {section !== RENTAL && showCharging && (
            <>
              {!isAccounter && <DashboardMenuItem pathName={pathName} />}

              {(isAccounter || isAdministrator) && (
                <StatisticsByDayMenuItem pathName={pathName} />
              )}

              {(isAccounter || isAdministrator) && (
                <StatisticsReportsMenuItem pathName={pathName} />
              )}

              {(isAdministrator || isManager || isOperator) && (
                <ChargePointsMenuItem pathName={pathName} />
              )}

              {isAdministrator && <LocationsMenuItem pathName={pathName} />}

              <MapMenuItem pathName={pathName} />

              {(isAdministrator || isAppDeveloper) && (
                <AspMenuItem pathName={pathName} />
              )}
            </>
          )}

          {isRentalManager && !showSwitcher && (
            <>
              <RentalDashboardMenuItem pathName={pathName} />
              <RentalCalendarMenuItem pathName={pathName} />
              <RentalDocumentsMenuItem pathName={pathName} />
              <RentalVehiclesMenuItem pathName={pathName} />
              <RentalRentalsMenuItem pathName={pathName} />
              <RentalClientsMenuItem pathName={pathName} />
              <RentalPaymentOperationsMenuItem pathName={pathName} />
              <RentalMapMenuItem pathName={pathName} />
              <RentalLocationsMenuItem pathName={pathName} />
            </>
          )}

          <ProfileMenuItem pathName={pathName} />

          {!loggedIn && (
            <>
              <Link to="/login"><Icon /> {t('login')}</Link>
              <Link to="/signup"><Icon /> {t('signup')}</Link>
            </>
          )}
        </LinkContainer>

      </SidebarBlock>
    );
  }
}

export default Sidebar;
